import apiCall from '../index'

const apiService = '/gsencuesta/api/v1/ubigeo/'

const service = {
  findAllDepartamento() {
    const query = 'departamento'
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findProvinciaByDepartamento(params) {
    const query = `provincia/${params.id}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findDistritoByProvincia(params) {
    const query = `distrito?codigoDepartamento=${params.codigoDepartamento}&codigoProvincia=${params.codigoProvincia}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  findCentroPobladoByProvinciaByDistrito(params) {
    const query = `centroPoblado?codigoDepartamento=${params.codigoDepartamento}&codigoProvincia=${params.codigoProvincia}&codigoDistrito=${params.codigoDistrito}`
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  createAllCentroPoblado(model) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .post(`${apiService}/import`, model)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
